import React from 'react';
import Slider from 'react-slick';
import DOMPurify from 'dompurify';

//UI
import RecomendationCards from '../../../components/cards/RecomendationCards';
import AllItinerariesCards from '../../../components/cards/AllItinerariesCards';
import Banner from '../../../components/banners/Banner';
import Sections from '../../../components/sections/Sections';
import FlagYacht from '../../../components/yachts/FlagYacht';
import Stats from '../../../components/stats/Stats';
import Partners from '../../../components/stats/Partners';
import passengers from '../../../assets/pruebas/Reviews-Galapagos-Cruises-Rolf-Wittmer.jpg';

const Home = ({ homeState, itineraries, yachtState }) => {

  const settings = {
    cssEase: "linear",
    infinite: true,
    dots: true,
    speed: 1500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    customPaging: (i) => (
      <div className="custom-dot"></div>
    ),
    appendDots: (dots) => (
      <ul style={{ margin: "0px" }}> {dots} </ul>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
  };

  const settingsTwo = {
    cssEase: "linear",
    infinite: true,
    dots: false,
    speed: 2000,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: true,
    customPaging: (i) => (
      <div className="custom-dot"></div>
    ),
    appendDots: (dots) => (
      <ul style={{ margin: "0px" }}> {dots} </ul>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
  };

  const sectionFive = homeState?.sections.filter(section => section.position === 5)

  return (

    <div name='home' className={`flex flex-col min-h-screen bg-fixed`}>
      <div className='bg-white/70'>
        <Banner state={homeState} buttons={'home'} />
        <div className={`my-5 w-full min-h-full p-5`}>
          <Stats />
        </div>
        <div className='my-5'>
          <Sections state={homeState?.sections[0]} />
        </div>
        <div className='bg-white/50 py-5'>
          <div className='md:my-3'>
            <h2 className='font-bold text-[30px] md:text-[55px] text-[#2e6a82] uppercase text-shadow-lg'>Why Our Galapagos</h2>
            <h2 style={{ fontFamily: 'BloomingHeart' }} className='text-amber-500 text-[50px] md:text-[80px] mt-[-25px] md:mt-[-50px]'>Cruises Stand Out</h2>
          </div>
          <div className='flex flex-col md:grid md:grid-cols-3 p-3 md:p-10 gap-3 text-white'>
            {
              sectionFive.map(section => (
                <div key={section.id} className={`flex flex-col py-8 justify-between h-[200px] items-center transition-all shadow-lg shadow-gray-500 rounded-md bg-gradient-to-b from-[#051937] to-[#004d7a]`}>
                  <h3 className='text-[30px] text-shadow-lg' style={{ fontFamily: 'BloomingHeart' }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(section.title) }}></h3>
                  <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(section.text) }}></p>
                </div>
              ))
            }
          </div>
        </div>
        <div className='flex flex-col md:grid md:grid-cols-4 mb-14'>
          {
            yachtState?.map(yacht => (
              <FlagYacht key={yacht.id} yacht={yacht} />
            ))
          }
        </div>
        <div className='w-full md:px-10 h-full mb-5 md:pb-10 bg-white/50'>
          <div className='md:my-3'>
            <h2 className='font-bold text-[30px] md:text-[55px] text-[#2e6a82] uppercase text-shadow-lg'>know all our</h2>
            <h2 style={{ fontFamily: 'BloomingHeart' }} className='text-amber-500 text-[50px] md:text-[80px] mt-[-25px] md:mt-[-50px]'>Itineraries</h2>
          </div>
          <Slider {...settings} className='h-[500px] flex justify-center items-center'>
            {
              itineraries?.map(itinerary => (
                <div className="p-3" key={itinerary.id}>
                  <AllItinerariesCards itineraryState={itinerary} />
                </div>
              ))
            }
          </Slider>
        </div>
        <Sections state={homeState.sections[1]} to={'/our-history'}>
          About us
        </Sections>
        <div className='w-full min-h-screen'>
          <div className="relative w-full h-[300px] flex justify-end transition-all">
            <img
              loading='lazy'
              src={passengers}
              alt="Passenger Reviews"
              className="absolute top-0 left-0 w-full h-full object-cover"
            />
            <div className="relative flex flex-col w-[55%] md:w-[50%] items-start justify-center text-white uppercase text-[30px] md:text-[45px] font-sans text-start">
              <h2>Passenger's</h2>
              <h2>Reviews</h2>
            </div>
          </div>
          <div className='p-5 md:p-10 h-full my-10 md:my-0 bg-orange'>
            <Slider {...settingsTwo} className='h-[450px] flex justify-center items-center gap-4 p-2'>
              {
                homeState.recomendation?.map(item => (
                  <RecomendationCards key={item.id} recomendationState={item} />

                ))
              }
            </Slider>
          </div>
        </div>
        <div className={`w-full min-h-full p-5`}>
          <Partners />
        </div>
      </div>
    </div>
  );
};

export default Home;
